import { RadioGroup } from '@headlessui/react'
import * as _ from 'lodash-es'
import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import { twMerge as mergeClassNames } from 'tailwind-merge'

/**
 *
 * RadioInput
 *
 */
const RadioInput = forwardRef(({ horizontal, label, name, onChange, options, value }, ref) => (
  <RadioGroup id={name} value={value} onChange={onChange} ref={ref}>
    <RadioGroup.Label className="text-charcoal pb-2 text-xs font-semibold uppercase leading-[14px] tracking-[1.5px]">
      {label}
    </RadioGroup.Label>
    <div className={horizontal ? 'flex flex-row space-x-6' : ''}>
      {_.map(options, (o) => (
        <RadioGroup.Option key={o.id} value={o.id}>
          {({ checked }) => (
            <div className="flex items-center">
              <input
                disabled={o.disabled}
                id={o.id}
                name={name}
                type="radio"
                defaultChecked={checked}
                readOnly
                className="text-purple h-4 w-4 border-gray-300 focus:ring-purple-600 disabled:opacity-50 disabled:hover:cursor-not-allowed"
              />

              <label
                htmlFor={o.id}
                className={mergeClassNames(
                  'ml-3 block text-sm font-medium leading-6 text-gray-900',
                  o.disabled && 'opacity-50 hover:cursor-not-allowed',
                )}
              >
                {o.label}
              </label>
            </div>
          )}
        </RadioGroup.Option>
      ))}
    </div>
  </RadioGroup>
))

RadioInput.defaultProps = {
  horizontal: false,
}

RadioInput.propTypes = {
  horizontal: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  value: PropTypes.string.isRequired,
}

export default RadioInput
